import 'babel-polyfill';
import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
import Root from './components/Root';
import configureStore from './store/configureStore';

const container = document.getElementById('app');

const store = configureStore({});
ReactDOM.render(<Root store={store} />, container);

if (module.hot) {
  module.hot.accept();
  module.hot.dispose(() => {
    ReactDOM.unmountComponentAtNode(container);
  });
}
